// extracted by mini-css-extract-plugin
module.exports = {"container":"blog_container__yiygp","heading":"blog_heading__1yfd1","card":"blog_card__2gAKa"};